import { useTranslation } from "react-i18next";
import { useMainContext } from "../../MainContext";
import "./styles.css";
import { ReactComponent as PlaneCircle } from "../../assets/map/plane-circle.svg";
import { ReactComponent as GroupCircle } from "../../assets/group.svg";
import { ReactComponent as Organization } from "../../assets/organization.svg";
import { isNullOrUndefined } from "../../utils";

function WelcomeWidget() {
  const { t } = useTranslation();
  const mainContext = useMainContext();
  const { currentUser } = mainContext;
  const welcomeMsg = t("welcome_back", { name: currentUser?.firstName });

  if (isNullOrUndefined(currentUser)) return null;
  return (
    <div className="welcome-widget">
      <div>
        <div className="welcome-widget-section">
          <h4>{welcomeMsg}</h4>
        </div>
      </div>
      <div>
        <div className="welcome-widget-section">
          <div className="welcome-widget-info">
            <div>
              <div className="icon-circle">
                <PlaneCircle />
              </div>
            </div>
            <div>
              <div className="welcome-widget-label">{t("airport")}</div>
              <div>{`${currentUser.airport.name} (${currentUser.airport.iata})`}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="welcome-widget-section">
          <div className="welcome-widget-info">
            <div>
              <div className="icon-circle">
                <Organization />
              </div>
            </div>
            <div>
              <div className="welcome-widget-label">{t("organization")}</div>
              <div>{currentUser.company.name}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="welcome-widget-section">
          <div className="welcome-widget-info">
            <div>
              <div className="icon-circle">
                <GroupCircle />
              </div>
            </div>
            <div>
              <div className="welcome-widget-label">{t("group")}</div>
              <div>{currentUser.userGroup.name}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeWidget;
